import React, { Component } from 'react';
import { simpleNotification } from '../../../utils/notifications';
import './AnnouncementManagement.scss';

class AnnouncementManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newMessage: '',
      newDisplay: false,
    };
  }

  componentDidMount() {
    const { token } = this.props.auth;
    this.props.getAnnouncementList(token);
  }

  componentDidUpdate(prevProps) {
    const { announcements } = this.props.admin;
    const prev = prevProps.admin.announcements;

    if (prev.isLoading && !announcements.isLoading) {
      if (announcements.errors.hasError) {
        simpleNotification({
          level: 'error',
          title: 'Error',
          message: announcements.errors.message || 'An error occurred.',
        });
      }
    }
  }

  handleCreate = (e) => {
    e.preventDefault();
    const { newMessage, newDisplay } = this.state;
    const { token } = this.props.auth;

    if (!newMessage.trim()) {
      simpleNotification({ level: 'warning', title: 'Validation', message: 'Message content is required.' });
      return;
    }

    this.props.createAnnouncement({ messageContent: newMessage.trim(), currentDisplay: newDisplay }, token);
    this.setState({ newMessage: '', newDisplay: false });
  }

  handleToggleDisplay = (announcement) => {
    const { token } = this.props.auth;
    this.props.updateAnnouncement(announcement.id, { currentDisplay: !announcement.currentDisplay }, token);
  }

  handleEditMessage = (announcement, newContent) => {
    const { token } = this.props.auth;
    if (!newContent.trim()) return;
    this.props.updateAnnouncement(announcement.id, { messageContent: newContent.trim() }, token);
  }

  render() {
    const { announcements } = this.props.admin;
    const { newMessage, newDisplay } = this.state;
    const list = announcements.data || [];

    return (
      <div className="AnnouncementMgmt">
        <h2 className="AnnouncementMgmt__title">Announcement Banners</h2>
        <p className="AnnouncementMgmt__subtitle">
          The most recent announcement with <strong>Display Active</strong> toggled on will be shown as a banner at the top of the website.
        </p>

        <form className="AnnouncementMgmt__form" onSubmit={this.handleCreate}>
          <h3>New Announcement</h3>
          <div className="AnnouncementMgmt__field">
            <label htmlFor="newMessage">Message Content</label>
            <textarea
              id="newMessage"
              value={newMessage}
              onChange={e => this.setState({ newMessage: e.target.value })}
              placeholder="Enter announcement message..."
              rows={3}
            />
          </div>
          <div className="AnnouncementMgmt__field AnnouncementMgmt__field--inline">
            <label htmlFor="newDisplay">Display Active</label>
            <input
              id="newDisplay"
              type="checkbox"
              checked={newDisplay}
              onChange={e => this.setState({ newDisplay: e.target.checked })}
            />
          </div>
          <button type="submit" className="AnnouncementMgmt__btn AnnouncementMgmt__btn--create">
            Create Announcement
          </button>
        </form>

        <div className="AnnouncementMgmt__list">
          <h3>All Announcements</h3>
          {announcements.isLoading && <p>Loading...</p>}
          {!announcements.isLoading && list.length === 0 && (
            <p className="AnnouncementMgmt__empty">No announcements yet.</p>
          )}
          {list.map(a => (
            <AnnouncementRow
              key={a.id}
              announcement={a}
              onToggle={this.handleToggleDisplay}
              onEdit={this.handleEditMessage}
            />
          ))}
        </div>
      </div>
    );
  }
}

class AnnouncementRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
      editValue: props.announcement.messageContent,
    };
  }

  handleSave = () => {
    const { announcement, onEdit } = this.props;
    const { editValue } = this.state;
    onEdit(announcement, editValue);
    this.setState({ editing: false });
  }

  render() {
    const { announcement, onToggle } = this.props;
    const { editing, editValue } = this.state;

    return (
      <div className={`AnnouncementMgmt__row ${announcement.currentDisplay ? 'AnnouncementMgmt__row--active' : ''}`}>
        <div className="AnnouncementMgmt__row-content">
          {editing ? (
            <textarea
              className="AnnouncementMgmt__edit-input"
              value={editValue}
              onChange={e => this.setState({ editValue: e.target.value })}
              rows={2}
            />
          ) : (
            <span className="AnnouncementMgmt__row-message">{announcement.messageContent}</span>
          )}
        </div>
        <div className="AnnouncementMgmt__row-actions">
          <label className="AnnouncementMgmt__toggle">
            <input
              type="checkbox"
              checked={announcement.currentDisplay}
              onChange={() => onToggle(announcement)}
            />
            <span>{announcement.currentDisplay ? 'Active' : 'Inactive'}</span>
          </label>
          {editing ? (
            <>
              <button type="button" className="AnnouncementMgmt__btn AnnouncementMgmt__btn--save" onClick={this.handleSave}>Save</button>
              <button type="button" className="AnnouncementMgmt__btn AnnouncementMgmt__btn--cancel" onClick={() => this.setState({ editing: false, editValue: announcement.messageContent })}>Cancel</button>
            </>
          ) : (
            <button type="button" className="AnnouncementMgmt__btn AnnouncementMgmt__btn--edit" onClick={() => this.setState({ editing: true })}>Edit</button>
          )}
        </div>
      </div>
    );
  }
}

export default AnnouncementManagement;
